<script setup>
import { computed } from 'vue';

import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import Spinner from 'shared/components/Spinner.vue';
import { useVoiceCallMetrics } from '../../composables/useVoiceCallMetrics';

const { metrics, isLoading } = useVoiceCallMetrics('teams');
const teams = computed(() => metrics.value.teams || []);
</script>

<template>
  <div class="w-full overflow-x-auto">
    <table v-if="teams.length" class="w-full min-w-[480px] text-sm">
      <thead>
        <tr class="border-b border-n-weak text-xs text-n-slate-11">
          <th class="px-3 py-3 text-start font-medium">
            {{ $t('VOICE_CALL_DASHBOARD.TEAMS.TEAM') }}
          </th>
          <th class="px-3 py-3 text-start font-medium">
            {{ $t('VOICE_CALL_DASHBOARD.TEAMS.ACTIVE') }}
          </th>
          <th class="px-3 py-3 text-start font-medium">
            {{ $t('VOICE_CALL_DASHBOARD.TEAMS.QUEUED') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="team in teams"
          :key="team.team_id"
          class="border-b border-n-weak text-n-slate-12 last:border-b-0"
        >
          <td class="px-3 py-3">{{ team.name }}</td>
          <td class="px-3 py-3">{{ team.active }}</td>
          <td class="px-3 py-3">{{ team.queued }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="isLoading" class="flex items-center justify-center p-8">
      <Spinner />
      <span>{{ $t('VOICE_CALL_DASHBOARD.LOADING') }}</span>
    </div>
    <EmptyState v-else :title="$t('VOICE_CALL_DASHBOARD.TEAMS.NO_TEAMS')" />
  </div>
</template>
